export const documentationLinks = {
  "home": "https://documentation.performahrm.com/dashboard.htm",
  "candidates.dashboard": "https://documentation.performahrm.com/scheda_nominativo.htm",
  "candidates": "https://documentation.performahrm.com/lista_nominativi.htm",
  "curriculum.general": "https://documentation.performahrm.com/anagrafica.htm",
  "curriculum.skills": "https://documentation.performahrm.com/competenze_1.htm",
  "curriculum.experiences": "https://documentation.performahrm.com/esperienze.htm",
  "curriculum.education": "https://documentation.performahrm.com/istruzione.htm",
  "curriculum.updates": "https://documentation.performahrm.com/aggiornamenti_1.htm",
  "curriculum.languages": "https://documentation.performahrm.com/lingue.htm",
  "curriculum.situation": "https://documentation.performahrm.com/inquadramento.htm",
  "curriculum.talent": "https://documentation.performahrm.com/talent_2.htm",
  "curriculum.documents": "https://documentation.performahrm.com/documenti_1.htm",
  "curriculum.screening": "https://documentation.performahrm.com/screening.htm",
  "curriculum.projects": "https://documentation.performahrm.com/progetti_1.htm",
  "curriculum.interview": "https://documentation.performahrm.com/colloquio.htm",
  "curriculum.privacy": "https://documentation.performahrm.com/privacy_2.htm",
  "curriculum.contracts": "https://documentation.performahrm.com/contratti_1.htm",
  "curriculum.courses": "https://documentation.performahrm.com/corsi.htm",
  "curriculum.response_offers": "https://documentation.performahrm.com/risposta_annunci.htm",
  "curriculum.meetings": "https://documentation.performahrm.com/appuntamenti_1.htm",
  "projects": "https://documentation.performahrm.com/lista_progetti.htm",
  "projects.general": "https://documentation.performahrm.com/generale_1.htm",
  "projects.recommended_names": "https://documentation.performahrm.com/nominativi_consigliati.htm",
  "projects.job_ads": "https://documentation.performahrm.com/annunci_2.htm",
  "projects.answer_ads": "https://documentation.performahrm.com/risposte_2.htm",
  "projects.candidates": "https://documentation.performahrm.com/candidati.htm",
  "projects.customer_area": "https://documentation.performahrm.com/area_clienti.htm",
  "projects.meetings": "https://documentation.performahrm.com/appuntamenti_2.htm",
  "projects.documents": "https://documentation.performahrm.com/documenti_2.htm",
  "projects.updates": "https://documentation.performahrm.com/aggiornamenti_2.htm",
  "interview": "https://documentation.performahrm.com/intervista.htm",
  "customers": "https://documentation.performahrm.com/lista_clienti.htm",
  "customer.general": "https://documentation.performahrm.com/generale_2.htm",
  "customer.updates": "https://documentation.performahrm.com/aggiornamenti_2.htm",
  "customer.contacts": "https://documentation.performahrm.com/contatti_1.htm",
  "customer.contracts": "https://documentation.performahrm.com/contratti_2.htm",
  "customer.proposals": "https://documentation.performahrm.com/proposte.htm",
  "customer.projects": "https://documentation.performahrm.com/progetti_3.htm",
  "customer.documents": "https://documentation.performahrm.com/documenti_3.htm",
  "customer.multibrand": "https://documentation.performahrm.com/multi_brand.htm",
  "calendar": "https://documentation.performahrm.com/calendario.htm",
  "graphics": "https://documentation.performahrm.com/grafici_2.htm",
  "candidate-analysis": "https://documentation.performahrm.com/analisi.htm",
  "channels-analysis": "https://documentation.performahrm.com/analisi.htm",
  "projects-analysis": "https://documentation.performahrm.com/analisi.htm",
  "candidature-analysis": "https://documentation.performahrm.com/analisi.htm",
  "email-template": "https://documentation.performahrm.com/template_email.htm",
  "email-sent": "https://documentation.performahrm.com/email_inviate.htm",
  "groups": "https://documentation.performahrm.com/gruppi_lavoro.htm",
  "users": "https://documentation.performahrm.com/lista_utenti.htm",
  "user.general": "https://documentation.performahrm.com/impostazioni_generali.htm",
  "user.changePassword": "https://documentation.performahrm.com/cambio_password_1.htm",
  "user.signature": "https://documentation.performahrm.com/firma_1.htm",
  "user.templateAppointment": "https://documentation.performahrm.com/template_appuntamenti_1.htm",
  "user.integration": "https://documentation.performahrm.com/integrazioni_1.htm",
  "system": "https://documentation.performahrm.com/system.htm",
  "documents-template": "https://documentation.performahrm.com/template_documenti.htm",
  "item-codes": "https://documentation.performahrm.com/opzioni.htm",
  "courses": "https://documentation.performahrm.com/corsi.htm",
  "skills": "https://documentation.performahrm.com/competenze_2.htm",
  "backups": "https://documentation.performahrm.com/backup.htm",
  "profile": "https://documentation.performahrm.com/profilo.htm",
  "settings": "https://documentation.performahrm.com/impostazioni.htm",
  "settings.tabSystem": "https://documentation.performahrm.com/sistema.htm",
  "settings.tabDefault": "https://documentation.performahrm.com/default.htm",
  "settings.tabTalent": "https://documentation.performahrm.com/talent_1.htm",
  "settings.tabPrivacy": "https://documentation.performahrm.com/privacy_1.htm",
  "settings.tabAdvertisement": "https://documentation.performahrm.com/annunci_1.htm",
  "settings.tabSpontaneousApplication": "https://documentation.performahrm.com/candidatura_spontanea.htm",
  "settings.tabAreaNominative": "https://documentation.performahrm.com/area_nominativi.htm",
  "settings.tabEmail": "https://documentation.performahrm.com/email_1.htm",
  "settings.tabIntegration": "https://documentation.performahrm.com/integrazioni_2.htm",
  "settings.tabAreaPersonale": "https://documentation.performahrm.com/area_personale.htm",
  "settings.cadidateCard": "https://documentation.performahrm.com/scheda_candidato.htm",


  "pipeline": "https://documentation.performahrm.com/pipeline.htm",
}
